<template>
  <div class="tw-w-full">
    <link rel="stylesheet" href="https://use.typekit.net/ysc7gpx.css">

  <div id="calc" class="tw-container tw-w-full tw-mx-auto">
    <ContactForm v-model="showForm" :calc-data="calcData" @close="showForm=false" />
    <div class="lg:tw-flex tw-pb-8 lg:tw-flex-row min-h-full h-full">
      <div class="tw-flex tw-flex-col tw-pr-2  lg:tw-w-1/2 tw-flex-initial calculations">
        <div>
          <h2 class="section_header">
            Your Company
          </h2>
          <div class="tw-flex tw-mb-4 tw-w-full">
            <div class="tw-w-full">
              <label for="pcs">How many computer users do you have?</label>
              <input :class="input_classes" id="pcs" v-model.number="pc_count" type="number" min="4">
            </div>
          </div>
          <div class="tw-flex tw-flex-auto tw-mb-4">
            <div class="tw-flex tw-flex-auto tw-w-full md:tw-space-x-4">
              <div class="tw-w-1/3">
                <label for="economic_count">Basic<br class="md:tw-hidden"> Users
                  <b-icon
                  v-b-tooltip.rightbottom="'Light user who uses the computer only 2 to 4 hours per day, and only runs a few applications that aren’t real-time sensitive. Think: receptionist, auto mechanic, hair stylist.'"
                  icon="info-circle"
                  style="color: #b247ff; display:inline">
                </b-icon>
                </label>
                <input :class="input_classes"  id="economic_count" v-model="economic_count" type="number" min="0" @input="economic_count_manual = true">
              </div>
              <div class="tw-w-1/3">
                <label for="standard_count">Standard<br class="md:tw-hidden"> Users
                  <b-icon
                  v-b-tooltip.rightbottom="'Uses the computer most or all of the day, has several office applications going at the same, and is very interactive with those applications.  Think: administrative assistant, HR administrator, office manager.'"
                  icon="info-circle"
                  style="color: #b247ff; display:inline">
                  </b-icon>
                </label>
                <input :class="input_classes"  id="standard_count" v-model="standard_count" type="number" min="0" @input="standard_count_manual = true">
              </div>
              <div class="tw-w-1/3">
                <label for="premium_count">Premium<br class="md:tw-hidden"> Users                  <b-icon
                  v-b-tooltip.rightbottom="'Power user using several office applications and 1 or more compute or data intense applications.  Computer is mission critical to their success, and responsiveness is of the essence. Think: Accountant, financial analyst, marketing digital content manager.'"
                  icon="info-circle"
                  style="color: #b247ff; display:inline">
                  </b-icon>
                </label>
                <input :class="input_classes"  id="premium_count" v-model="premium_count" type="number" min="0" @input="premium_count_manual = true">
              </div>
            </div>
          </div>
          <div class="tw-flex tw-mb-4 tw-w-full md:tw-space-x-4">
            <div class="tw-w-1/2">
              <label for="location_count">How many Business Locations do you have?</label>
              <input :class="input_classes"  id="location_count" v-model.number="location_count" type="number" min="1" @input="location_count_manual = true">
            </div>
            <div class="tw-w-1/2">
              <label for="servers">How many servers do you have?</label>
              <input :class="input_classes"  id="servers" v-model.number="server_count" type="number" min="0" @input="server_count_manual = true">
            </div>
          </div>
        </div>
        <div>
          <h2 class="section_header">
            IT Management
          </h2>
          <div class="tw-flex tw-mb-4 tw-w-full">
            <div class=" tw-w-full">
              <label>How many total minutes per day are your employees experiencing slow IT?</label>
              <ButtonGroupBS v-model="slow_selection" :buttons="slow_buttons" class="tw-w-full" />
            </div>
          </div>
          <div class="tw-flex tw-mb-4 tw-w-full">
            <div class="tw-w-full">
              <label>How many hours per week does your business spend working on IT issues</label>
              <ButtonGroupBS v-model="hours_it_selection" :buttons="hours_it_buttons" class="tw-w-full" />
            </div>
          </div>
          <div class="tw-flex tw-mb-4 tw-w-full">
            <div class="tw-w-full">
              <label for="other_it">Current Monthly IT Management Costs?</label>
              <currency-input :class="input_classes"  id="other_it" v-model="other_it"  @input="other_it_manual = true" />
            </div>
          </div>
        </div>
        <div>
          <h2 class="section_header">
            Risk Management
          </h2>
          <div class="tw-w-full">
            <tw-small class="tw-block tw-leading-normal">(Based on your answers above, this is the anticipated exposure for your business. You can leave the pre-populated industry averages or overwrite them with numbers you feel are more accurate.)</tw-small>
          </div>
          <div class="tw-w-full">
            <label for="revenue">Annual Revenue</label>
            <currency-input
              id="revenue"
              v-model="revenue"
              v-bind="money"
              :class="[input_classes, 'tw-bg-gray-500']"
              @input="revenue_manual = true"
            />
          </div>
          <div class="tw-w-full">
            <label for="disaster_cost">If your physical location was destroyed, what would it cost to rebuild all your accumulated onsite data?</label>
            <currency-input
              id="disaster_cost"
              :class="[input_classes, 'tw-bg-gray-500']"
              v-model="disaster_cost"
              @input="disaster_cost_manual = true"
            />
          </div>
          <div class="tw-w-full">
            <label for="ransomware_costs">If your office was hit by ransomware, what would it cost?</label>
            <currency-input
              id="ransomware_costs"
              :class="[input_classes, 'tw-bg-gray-500']"
              v-model="ransomware_costs"
              @input="ransomware_costs_manual = true"
            />
            <CalcSource
              url=""
              title="Calculating Ransomware Cost"
              body="See:<br>
              <a href='https://www.convergetechmedia.com/fifty-percent-businesses-report-ransomware-attacks-past-year' target='_blank'>https://www.convergetechmedia.com/fifty-percent-businesses-report-ransomware-attacks-past-year</a> <br><br>
              <a href='https://www.coveware.com/blog/2019/4/15/ransom-amounts-rise-90-in-q1-as-ryuk-ransomware-increases' target='_blank'>https://www.coveware.com/blog/2019/4/15/ransom-amounts-rise-90-in-q1-as-ryuk-ransomware-increases</a> <br><br>
              <a href='https://www.comparitech.com/antivirus/ransomware-statistics/' target='_blank'>https://www.comparitech.com/antivirus/ransomware-statistics/</a>"
            />
          </div>
          <div class="tw-w-full">
            <label for="breach_costs">If your office suffered a data breach, what would it cost?</label>
            <currency-input
              id="breach_costs"
              v-model="breach_costs"
              :class="[input_classes, 'tw-bg-gray-500']"
              @input="breach_costs_manual = true"
            />
            <CalcSource
              url=""
              title="Calculating Breach Impact"
              body="
              See:<br>
              <a href='https://staysafeonline.org/tw-small-business-target-survey-data/' target='_blank'>https://staysafeonline.org/tw-small-business-target-survey-data/</a> <br><br>
              <a href='https://blog.knowbe4.com/data-breaches-devastate-tw-small-businesses-in-2019-with-10-percent-closing-their-doors' target='_blank'>https://blog.knowbe4.com/data-breaches-devastate-tw-small-businesses-in-2019-with-10-percent-closing-their-doors <br><br>
              <a href='https://www.bluefin.com/bluefin-news/highlights-ibm-security-ponemon-institutes-2019-cost-data-breach-study/' target='_blank'>https://www.bluefin.com/bluefin-news/highlights-ibm-security-ponemon-institutes-2019-cost-data-breach-study/ <br><br>
              <a href='https://blog.tresorit.com/the-top-6-takeaways-from-the-2019-cost-of-a-data-breach-report' target='_blank'>https://blog.tresorit.com/the-top-6-takeaways-from-the-2019-cost-of-a-data-breach-report <br><br>
              <a href='https://www.all-about-security.de/cost-of-a-data-breach-studie-2019-wachsende-risiken-fuer-kleine-unternehmen/' target='_blank'>https://www.all-about-security.de/cost-of-a-data-breach-studie-2019-wachsende-risiken-fuer-kleine-unternehmen/</a>"
            />
          </div>
        </div>
      </div>
            <div class="tw-flex-col tw-ml-2">
                                 <div class="kloud-savings ">
                                  <h2 class="section_header"> Kloudation Savings </h2>
                                  <div class="tw-flex tw-w-full tw-flex-column">
                                    <div class="tw-card-header tw-w-full"><span class="tw-badge tw-badge-success tw-float-right">Yearly Savings</span>
                                      <h5 class="tw-card-title tw-mb-0">IT Cost Reduction</h5>
                                    </div>
                                    <div class="tw-my-2 tw-w-full">
                                      <div class="tw-flex tw-flex-row">
                                        <div class="tw-col-8">
                                          <h2 style="font-size: 38px">{{ formatPrice(net_annual_savings) }}</h2>
                                        </div>
                                        <div class="tw-text-right tw-col-4"><h3 style="font-size: 32px"><span class="tw-badge">{{ percentageSavings }}</span></h3></div>
                                      </div>
                            <progress-bar
                              :options="progressBarOptions"
                              :value="parseFloat(((net_annual_savings / total_no_kloud)*100).toFixed(2))"
                            />
                                    </div>
                                  </div>


        <div>
          <div class="tw-flex" style="overflow: auto;max-height: 40vh;">
            <table class="tw-w-full tw-border-0">
              <thead>
                <tr class="tw-border-0">
                  <th class="tw-text-left">
                    <h2 class="section_header">
                      Annualized Cost Summary
                    </h2>
                  </th>
                  <th class="tw-w-1/6">
                    Traditional
                  </th>
                  <th class="tw-pl-5 tw-w-1/6">
                    Kloudation
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr :class="(calc.label === 'Kloudation Costs' || calc.label.startsWith('-'))?'tw-border-0 tw-bg-kloudpurple':'tw-border-0'" v-for="calc in cost_savings_calc" :key="calc.label" >
                  <td>
<!--                    <template v-if="calc.label === 'Kloudation Costs' && !kloudation_cost_detail">-->
<!--                      <a class="cursor-pointer select-none" @click.prevent="kloudation_cost_detail = true">[+] {{ calc['label'] }}</a>-->
<!--                    </template>-->
<!--                    <template v-else-if="calc.label === 'Kloudation Costs' && kloudation_cost_detail">-->
<!--                      <a class="cursor-pointer select-none" @click.prevent="kloudation_cost_detail = false">[-] {{ calc['label'] }}</a>-->
<!--                    </template>-->
<!--                    <template v-else>-->
<!--                      {{ calc['label'] }}-->
<!--                    </template>-->
                    {{ calc['label'] }}
                  </td>
                  <td class="tw-text-right">
                    <template v-if="calc.label !== 'Kloudation Costs' || !kloudation_cost_detail">
                      {{ formatPrice(calc['no_kloud']) }}
                    </template>
                  </td>
                  <td class="tw-text-right">
                    <template v-if="calc.label !== 'Kloudation Costs' || !kloudation_cost_detail">
                      {{ formatPrice(calc['kloud']) }}
                    </template>
                  </td>
                </tr>
                <tr class="tw-border-0 tw-bg-kloudpurple tw-small">
                  <td class="tw-pl-5">
                    - Organization Pricing
                  </td>
                  <td class="tw-text-right" />
                  <td class="tw-text-right">
                    {{ formatPrice(organization_price * 12) }}
                  </td>
                </tr>
                <tr class="tw-border-0 tw-bg-kloudpurple tw-small">
                  <td class="tw-pl-5">
                    - Site Pricing
                  </td>
                  <td class="tw-text-right" />
                  <td class="tw-text-right">
                    {{ formatPrice(site_price * 12) }}
                  </td>
                </tr>
<!--                <tr  class="tw-border-0" v-if="kloudation_cost_detail">-->
                <tr class="tw-border-0 tw-bg-kloudpurple tw-small">
                  <td class="tw-pl-5">
                    - User Pricing
                  </td>
                  <td class="tw-text-right" />
                  <td class="tw-text-right">
                    {{ formatPrice(user_price * 12) }}
                  </td>
                </tr>
                <tr  class="tw-border-0">
                  <td>Total Estimated Averaged Costs</td>
                  <td class="tw-border-t-2 tw-text-right">
                    {{ formatPrice(total_no_kloud) }}
                  </td>
                  <td class="tw-border-t-2 tw-text-right">
                    {{ formatPrice(total_kloud) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div />
        <div class="tw-mt-3">
          <div class="tw-flex tw-flex-col tw-w-full">
            <div class="">
              <button class="tw-bg-kloudpurple tw-grid tw-text-black tw-py-3 tw-px-4 tw-mr-0 tw-m-auto" @click.prevent="showForm=true">
                Request A Quote!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
      </div>
</template>

<script>
/* eslint-disable no-unused-vars,brace-style */
import { Money } from 'v-money'

import CalcSource from './CalcSource'
import ButtonGroupBS from './ButtonGroupBS'
import ContactForm from './ContactForm'
import './VueTooltip.scss';
import { VBTooltip } from 'bootstrap-vue';

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'Simple',
  components: { ContactForm, ButtonGroupBS, CalcSource, Money },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data () {
    const Constants = {
      WeeksPerYear: 365.25 / 7,
      WeeksPerMonth: 365.25 / 7 / 12,
      WorkHoursPerMonth: 365.25 / 7 / 12 * 40,

      PCCost: 800,
      PhysicalServerCost: 10000,
      CostOfNetworking: 0.20,
      AvgPCLife: 5,
      AvgServerLife: 7,
      AvgVMPerHost: 4,
      ServerAnnualMaintenance: 1400,
      ServerLicense: 1600,
      ServerSA: 400,

      RecordsPerEmployee: 50,

      AvgAnnualWages: 51865.50, // https://www.bls.gov/news.release/pdf/wkyeng.pdf
      AvgRevenuePerEmployee: 100000, // https://tw-smallbusinessmattersonline.com/revenue-per-employee-calculation/
      TaxAddon: 0.15,
      BenefitsAddon: 0.15,

      ITLaborHoursPerPCMonth: 1.5,
      SkilledLaborAddon: 0.50,

      BreachCostPerRecord: 150,
      BreachCostPerEmployee: 3533
    }

    const Buttons = {
      isp_buttons: [
        {
          text: 'Good',
          classes: 'tw-text-green-100 tw-bg-green-700 hover:tw-bg-green-800'
        },
        {
          text: 'Neutral',
          classes: 'tw-text-indigo-100 tw-bg-indigo-700 hover:tw-bg-indigo-800'
        },
        {
          text: 'Bad',
          classes: 'tw-text-red-100 tw-bg-red-700 hover:tw-bg-red-800'
        }
      ],
      slow_buttons: [
        {
          text: 'Under 30',
          classes: 'tw-text-green-100 tw-bg-green-500 hover:tw-bg-green-800'
        },
        {
          text: '30 - 60 min',
          classes: 'tw-text-indigo-100 tw-bg-indigo-500 hover:tw-bg-indigo-800'
        },
        {
          text: 'Over 60',
          classes: 'tw-text-red-100 tw-bg-red-500 hover:tw-bg-red-800'
        }
      ],
      hours_it_buttons: [
        {
          text: 'Under 3',
          classes: 'tw-text-green-100 tw-bg-green-500 hover:tw-bg-green-800'
        },
        {
          text: '3 - 5 hours',
          classes: 'tw-text-indigo-100 tw-bg-indigo-500 hover:tw-bg-indigo-800'
        },
        {
          text: 'Over 5',
          classes: 'tw-text-red-100 tw-bg-red-500 hover:tw-bg-red-800'
        }
      ]
    }
    const progressBarOptions = {
      text: {
    color: '#FFFFFF',
    shadowEnable: true,
    shadowColor: '#000000',
    fontSize: 12,
    fontFamily: 'itc-avant-garde-gothic-pro, sans-serif',
    dynamicPosition: false,
    hideText: false
  },
  progress: {
    color: '#b257ff',
    backgroundColor: '#ddd'
  },
  layout: {
    height: 20,
    verticalTextAlign: 66,
    horizontalTextAlign: 43,
    zeroOffset: 0,
    strokeWidth: 30,
    progressPadding: 0,
    type: 'line'
  }
    }

    return {
      pc_count: 4,
      server_count: 0,
      server_count_manual: false,
      location_count: 1,
      location_count_manual: false,
      isp_cost: 0,
      isp_cost_manual: false,
      // mins_wasted: 0,
      // mins_wasted_manual: false,
      slow_selection: 1,
      hours_it_selection: 1,
      // hours_spent: 0,
      // hours_spent_manual: false,
      employee_count: 0,
      employee_count_manual: false,
      payroll: 0,
      payroll_manual: false,
      revenue: 0,
      revenue_manual: false,
      other_it: 0,
      other_it_manual: false,
      disaster_cost: 0,
      disaster_cost_manual: false,
      ransomware_costs: 0,
      ransomware_costs_manual: false,
      breach_costs: 0,
      breach_costs_manual: false,
      premium_count: 0,
      premium_count_manual: false,
      standard_count: 0,
      standard_count_manual: false,
      economic_count: 0,
      economic_count_manual: false,
      kloudation_cost_detail: false,
      ...Constants,
      ...Buttons,
      progressBarOptions,
      showForm: false,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 0,
        masked: false
      },
      input_classes: 'tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg tw-py-2 tw-px-4 tw-block tw-w-full tw-appearance-none tw-text-black'
    }
  },
  computed: {
    percentageSavings () {
      return this.formatPercentage(this.net_annual_savings / this.total_no_kloud)
    },
    calcData () {
      return {
        server_count: this.server_count,
        server_count_manual: this.server_count_manual,
        location_count: this.location_count,
        location_count_manual: this.location_count_manual,
        // isp_cost: this.isp_cost,
        // isp_cost_manual: this.isp_cost_manual,
        // mins_wasted: this.mins_wasted,
        // mins_wasted_manual: this.mins_wasted_manual,
        // hours_spent: this.hours_spent,
        // hours_spent_manual: this.hours_spent_manual,
        hours_it_selection: this.hours_it_selection,
        slow_selection: this.slow_selection,
        employee_count: this.employee_count,
        employee_count_manual: this.employee_count_manual,
        // payroll: this.payroll,
        // payroll_manual: this.payroll_manual,
        revenue: this.revenue,
        revenue_manual: this.revenue_manual,
        other_it: this.other_it,
        other_it_manual: this.other_it_manual,
        disaster_cost: this.disaster_cost,
        disaster_cost_manual: this.disaster_cost_manual,
        ransomware_costs: this.ransomware_costs,
        ransomware_costs_manual: this.ransomware_costs_manual,
        breach_costs: this.breach_costs,
        breach_costs_manual: this.breach_costs_manual,
        premium_count: this.premium_count,
        premium_count_manual: this.premium_count_manual,
        standard_count: this.standard_count,
        standard_count_manual: this.standard_count_manual,
        economic_count: this.economic_count,
        economic_count_manual: this.economic_count_manual
      }
    },
    net_annual_savings () {
      return this.savings // - (this.kld_costs * 12)
    },
    savings () {
      return this.total_no_kloud - this.total_kloud
    },
    kld_costs () {
      return this.organization_price + this.site_price + this.user_price
    },
    organization_price () {
      return (this.pc_count > 15 || this.location_count > 1) ? 795 : 0
    },
    site_price () {
      return ((this.pc_count > 15 || this.location_count > 1) ? 795 : 195) * this.location_count
    },
    user_price () {
      return this.economic_count * 138 + this.standard_count * 188 + this.premium_count * 268
    },
    total_no_kloud () {
      return this.cost_savings_calc.reduce((total, obj) => obj.no_kloud + total, 0)
    },
    total_kloud () {
      return this.cost_savings_calc.reduce((total, obj) => obj.kloud + total, 0)
    },
    cost_savings_calc () {
      return [
        {
          label: 'Cost of Workstations',
          no_kloud: this.pc_count * this.PCCost / this.AvgPCLife,
          kloud: 0
        },
        {
          label: 'Cost of Office Applications',
          no_kloud: this.pc_count * 12.50 * 12,
          kloud: 0
        },
        {
          label: 'Cost of Server Hardware',
          no_kloud: this.server_count === 0 ? 0 : Math.floor((1 + this.server_count / this.AvgVMPerHost) * 100) / 100 * (this.PhysicalServerCost / this.AvgServerLife + this.ServerAnnualMaintenance),
          kloud: 0
        },
        {
          label: 'Cost of Server OS Licensing',
          no_kloud: this.server_count === 0 ? 0 : Math.max(1, Math.floor(this.server_count * this.AvgVMPerHost / 2)) * (this.ServerSA / 2 + this.ServerLicense / this.AvgServerLife),
          kloud: 0
        },
        {
          label: 'IT Labor Costs',
          no_kloud: this.hours_spent / 40 * this.AvgAnnualWages * (1 + this.TaxAddon + this.BenefitsAddon) * (1 + this.SkilledLaborAddon),
          kloud: 0
        },
        {
          label: 'IT Management Cost',
          no_kloud: this.other_it * 12,
          kloud: 0
        },
        {
          label: 'Productivity Loss Costs',
          no_kloud: this.mins_wasted / 60 * this.payroll * 12,
          kloud: 0
        },
        {
          label: 'Est. Avg. Cost of Business Destruction',
          no_kloud: this.disaster_cost * 0.02,
          kloud: 0
        },
        {
          label: 'Est. Avg. Cost of Ransomware Infection',
          no_kloud: this.ransomware_costs * 0.25,
          kloud: 0
        },
        {
          label: 'Est. Avg. Cost of Data Breach',
          no_kloud: this.breach_costs * 0.148,
          kloud: this.breach_costs * 0.03
        },
        {
          label: 'Kloudation Costs',
          no_kloud: 0,
          kloud: this.kld_costs * 12
        }
      ]
    },
    watch_fields () {
      return [
        this.pc_count,
        this.server_count,
        this.location_count,
        this.isp_cost,
        // this.mins_wasted,
        // this.hours_spent,
        this.employee_count,
        this.payroll,
        this.revenue,
        this.other_it,
        this.disaster_cost,
        this.ransomware_costs,
        this.breach_costs,
        this.premium_count,
        this.standard_count,
        this.economic_count
      ].join()
    },
    mins_wasted () {
      switch (this.slow_selection) {
        case 0:
          return 1
        case 1:
          return 3
        case 2:
          return 6
        default:
          return 3
      }
    },
    hours_spent () {
      switch (this.hours_it_selection) {
        case 0:
          return 1.5
        case 1:
          return 4
        case 2:
          return 7
        default:
          return 4
      }
    }
  },
  watch: {
    watch_fields: {
      immediate: true,
      handler () {
        this.calc_defaults()
      }
    }
  },
  methods: {
    calc_defaults () {
      if (!this.server_count_manual) {
        this.server_count = this.pc_count < 12 ? 0 : 1 + Math.floor(this.pc_count / 30)
      }
      if (!this.location_count_manual) {
        this.location_count = 1 + Math.floor(this.pc_count / 40)
      }
      if (!this.isp_cost_manual) {
        if (this.pc_count < 5) { this.isp_cost = 60 }
        else if (this.pc_count <= 12) { this.isp_cost = 200 }
        else if (this.pc_count < 20) { this.isp_cost = 400 }
        else { this.isp_cost = 800 }
      }
      // if (!this.mins_wasted_manual) {
      //   this.mins_wasted = 60 * 0.05
      // }
      // if (!this.hours_spent_manual) {
      //   this.hours_spent = Math.floor(this.pc_count * this.ITLaborHoursPerPCMonth / this.WeeksPerMonth * 100) / 100
      // }
      if (!this.employee_count_manual) {
        this.employee_count = this.pc_count
      }
      if (!this.payroll_manual) {
        this.payroll = Math.floor(this.employee_count * this.AvgAnnualWages / 12 * (1 + this.TaxAddon + this.BenefitsAddon) * 100) / 100
      }
      if (!this.revenue_manual) {
        this.revenue = (this.employee_count * this.AvgRevenuePerEmployee)
      }
      if (!this.disaster_cost_manual) {
        // All new PCs plus physical servers + 30% (network) + 20 hours per employee + 2 weeks of lost revenue
        this.disaster_cost = (this.pc_count * this.PCCost + this.server_count * this.PhysicalServerCost) *
          (1 + this.CostOfNetworking) + this.employee_count * (this.AvgAnnualWages) /
          this.WeeksPerYear / 2 + this.revenue / this.WeeksPerYear * 2
        // this.disaster_cost = this.disaster_cost.toFixed(2)
      }
      if (!this.ransomware_costs_manual) {
        // 8 hours per employee + 1 day of lost revenue + 40 hours IT Labor + 40 Hours IT Labor per Server
        this.ransomware_costs = this.employee_count * this.AvgAnnualWages * (1 + this.TaxAddon + this.BenefitsAddon) / this.WeeksPerYear / 5 +
          this.revenue / this.WeeksPerYear / 5 +
          (this.AvgAnnualWages * (1 + this.TaxAddon + this.BenefitsAddon) * (1 + this.SkilledLaborAddon) / this.WeeksPerYear) * (1 + this.server_count)
        // this.ransomware_costs = this.ransomware_costs.toFixed(2)
      }
      if (!this.breach_costs_manual) {
        // Breach Recovery costs (Legal, Sales, Added Security) + 40 hours IT Labor + 40 Hours IT Labor per Server
        this.breach_costs = this.employee_count * this.BreachCostPerEmployee + (this.AvgAnnualWages * (1 + this.TaxAddon + this.BenefitsAddon) * (1 + this.SkilledLaborAddon) / this.WeeksPerYear) * (1 + this.server_count)
        // this.breach_costs = this.breach_costs.toFixed(2)
      }
      if (!this.economic_count_manual) {
        this.economic_count = Math.floor(this.pc_count * 0.40)
      }
      if (!this.standard_count_manual) {
        this.standard_count = Math.floor(this.pc_count * 0.50)
      }
      if (!this.premium_count_manual) {
        this.premium_count = Math.max(0, this.pc_count - this.standard_count - this.economic_count)
      }
      if (!this.other_it_manual) {
        this.other_it = 0
      }
    },
    reset () {
      Object.assign(this.$data, this.$options.data.apply(this))
      this.calc_defaults()
    },
    formatPrice (value) {
      if (typeof value !== 'number') {
        return value
      }
      value = value.toFixed(0)
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
      })
      return formatter.format(value)
    },
    formatPercentage (value) {
      if (typeof value !== 'number') {
        return value
      }
      return (value * 100).toFixed(2) + '%'
    }
  }
}
</script>

<style lang="postcss">
input {
    @apply tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg tw-py-2 tw-px-4 tw-block tw-w-full tw-appearance-none tw-text-black
}

textarea {
    @apply tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg tw-py-2 tw-px-4 tw-block tw-w-full tw-appearance-none tw-text-black
}

.section_header {
    @apply tw-m-2 tw-font-extrabold tw-text-2xl tw-text-black
}

table,
th,
tr,
td {
    border: 0;
}

div {
    font-family: itc-avant-garde-gothic-pro, sans-serif;
    font-weight: 300;
}

.container {
    width: 80%!important;
}

#calc {
    width: auto !important;
    margin: 0 -20px;
}

@media (max-width: 639px) {
    #calc .kloud-savings {
        padding: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
    }
    .entry-content thead th,
    .entry-content tr th,
    body.et-pb-preview #main-content .container thead th,
    body.et-pb-preview #main-content .container tr th {
        padding: 9px 15px;
    }
    .flex-auto .w-1\/3.sm\:w-full {
        width: 100%;
    }
    .flex-auto .w-1\/3.sm\:w-full.pl-4 {
        padding-left: 0;
        margin-top: 1rem;
    }
}

@media (min-width: 640px) {
    .container {
        max-width: 640px;
    }
}

@media (min-width: 768px) {
    .container {
        max-width: auto;
    }
}

@media (min-width: 1024px) {
    .container {
        max-width: 1024px;
    }
}

@media (min-width: 1280px) {
    .container {
        max-width: 1280px;
    }
}

@media (min-width: 1536px) {
    .container {
        max-width: 1536px;
    }
}

#calc {
    padding-top: 0 !important;
}

#calc .calculations>div {
    background: rgba(23, 0, 65, 0.07) !important;
    margin-bottom: 1rem;
    padding: 1rem;
    tw-border-radius: 0.5rem;
}

#calc .section_header {
    line-height: .9;
    margin: 0;
    padding: 0;
}

#calc .kloud-savings {
    padding: 1rem;
    border-radius: 0.5rem;
    box-shadow: 0 0 0.875rem 0 rgba(53, 64, 82, 0.15);
}

#calc .tw-bg-kloudpurple.grid {
    border: 2px solid #b247ff;
    color: #b247ff;
    background: white;
}

@media only screen and (min-width: 767px) {
    #page-container {
        overflow-y: visible !important;
    }
    #calc .kloud-savings {
        position: sticky !important;
        top: 100px !important;
        margin-left: 3rem;
    }
}

.badge {
    padding: 0.25em 0.45em;
    font-size: 80%;
    font-weight: 400;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.2rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, tw-border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    padding-top: .3rem;
}

h5.tw-card-title {
    font-size: 1rem;
    font-weight: normal;
}

.tw-float-right {
    float: right !important;
}

.tw-badge-success {
    color: #fff;
    background-color: #4BBF73;
}

.tw-flex-row {
    flex-direction: row;
}

.tw-flex-column {
    flex-direction: column;
}

.tw-d-tw-flex {
    display: flex;
    align-items: center;
}

.tw-row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -12px;
    margin-left: -12px;
}

.tw-col-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
}

.tw-col-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
}

.et_pb_counter_amount {
    background-color: #b257ff;
}

.et_pb_counter_amount.overlay {
    color: #b257ff;
}

.tw-bg-green-500 {
    background-color: rgba(23, 0, 65, .3)!important;
    color: white!important;
}

.tw-bg-indigo-500 {
    background-color: rgba(23, 0, 65, .6)!important;
    color: white!important;
}

.tw-bg-red-500 {
    background-color: rgba(23, 0, 65, 1)!important;
    color: white!important;
}

.tw-border-4 {
    border: none;
    outline: 4px solid #b257ff;
    z-index: 5;
}

input.tw-bg-gray-500 {
    background-color: rgba(23, 0, 65, 0.1) !important;
    color: black!important;
}

tr.tw-bg-kloudpurple {
    --tw-bg-opacity: .1;
    background-color: rgba(178, 87, 255, var(--tw-bg-opacity));
}

tr.tw-small td {
    font-size: 80%
}

td.tw-pl-5 {
    padding-left: 2rem!important;
}

.vuejs-progress-bar {
    width: 100% !important;
}

#line-progress {
    width: 100% !important;
}

label .et-pb-icon {
    font-size: 16px;
    position: relative;
    top: 2px;
    margin-left: .1rem;
    color: #b247ff;
}

</style>
